export default {
  title: "Persoons nummers",

  input: {
    title: "Persoons nummers {{action}}",
    socialSecurityNumber: {
      label: "BSN",
      notFound: "Nog geen BSN ingevoerd",
    },
  },
}
